/**
 * 获取用户数据
 */
export const user = state => {
  return state.user
}
/**
 * 获取配置数据
 */
export const options = state => {
  return state.options
}

/**
 * 获取用户登录状态
 */
export const isLogin = state => {
  return !!Object.keys(state.user).length
}

/**
 * 获取用户是否有实名认证
 */
export const isReadname = (state, getters) => {
  return getters.isLogin && state.user.cert.name && state.user.cert.status === 1
}

export const isVideoPlaying = state => {
  return state.isVideoPlaying
}

export const videoType = state => {
  return state.videoType
}



// WEBPACK FOOTER //
// ./src/store/getters.js